import NavBar from "../Components/NavBar/NavBar";
import AnimationTitleHeader from "../Components/AnimationTitleHeader/AnimationTitleHeader";

const Header = () => {
  return (
    <div className="header">
      <AnimationTitleHeader />
      <NavBar />
    </div>
  );
};

export default Header;
